export default __webpack_public_path__ + "static/media/DepEd-MATATAG_BagongPilipinas.0d38d68e.png";